module.exports = __webpack_public_path__ + "static/media/010.166f6f47.jpg";